import './index.scss';
import { Button } from 'ii-react-sdk/form_components';
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { useLocation, useNavigate } from 'react-router-dom';
import Modal from '~/components/modal';
import { UploadDocumentProvider, useUploadDocument } from './upload_provider';
const ACCEPTED_FILE_TYPES = [
    'application/pdf',
];
const UploadDocumentModal = (props) => {
    const { isModalVisible, hideModal } = props;
    const navigate = useNavigate();
    const { pathname, search: locationSearch } = useLocation();
    const searchParams = new URLSearchParams(locationSearch);
    const { selectedFiles, setSelectedFiles, submitFiles, uploadInProgress, uploadComplete, successfulUploads, failedUploads, successMessage, errorMessage, resetModel, } = useUploadDocument();
    const onDrop = useCallback((acceptedFiles) => {
        resetModel();
        setSelectedFiles(acceptedFiles);
    }, [setSelectedFiles]);
    const { getRootProps, getInputProps, } = useDropzone({ multiple: true, accept: ACCEPTED_FILE_TYPES.join(', '), onDrop });
    const onHideModel = () => {
        resetModel();
        hideModal();
    };
    const getFileSize = (file) => {
        let fileSize = `${file.size} bytes`;
        if (file.size > 2000) {
            fileSize = `${Math.round(file.size / 1000)} KB`;
        }
        if (file.size > 2000000) {
            fileSize = `${Math.round(file.size / 1000000)} MB`;
        }
        return fileSize;
    };
    const files = React.createElement(React.Fragment, null,
        React.createElement("li", null,
            React.createElement("div", { className: 'file-name-header' }, "Document Name"),
            React.createElement("div", { className: 'file-id-header' }, "Transaction ID")),
        selectedFiles.map((file) => {
            const uploadedFile = successfulUploads.find(u => u.fileName === file.name);
            return React.createElement("li", { key: file.name },
                React.createElement("div", { className: 'file-name' },
                    file.name,
                    " - ",
                    getFileSize(file)),
                React.createElement("div", { className: 'file-id' }, uploadedFile !== undefined && React.createElement(React.Fragment, null, uploadedFile.txId)),
                !uploadInProgress && !uploadComplete &&
                    React.createElement("span", { className: 'remove-file', onClick: () => setSelectedFiles(selectedFiles.filter(sf => sf.name !== file.name)) },
                        React.createElement("i", { className: 'fas fa-times' })),
                uploadInProgress &&
                    uploadedFile === undefined &&
                    !failedUploads.includes(file.name) &&
                    React.createElement("span", null,
                        React.createElement("i", { className: 'fas fa-spinner fa-pulse' })),
                uploadedFile !== undefined &&
                    React.createElement("span", { className: 'successful-upload' },
                        React.createElement("i", { className: 'fas fa-check' })),
                failedUploads.includes(file.name) &&
                    React.createElement("span", { className: 'failed-upload' },
                        React.createElement("i", { className: 'fas fa-exclamation-circle' })));
        }));
    return (React.createElement(Modal, { className: 'add-document-modal', visible: isModalVisible, onHide: uploadInProgress ? undefined : onHideModel },
        React.createElement("div", { className: 'title' },
            React.createElement("h6", null, "Upload Documents")),
        React.createElement("div", { className: 'document-form' },
            React.createElement("div", Object.assign({}, getRootProps({ className: 'dropzone' })),
                React.createElement("input", Object.assign({}, getInputProps())),
                React.createElement("p", null, "Drag documents, or click to select files")),
            React.createElement("div", { className: 'selected-files-container' }, selectedFiles && React.createElement("ul", null, files)),
            React.createElement("div", { className: 'msg-btn' },
                React.createElement(React.Fragment, null,
                    !!(errorMessage.length) && React.createElement("div", { className: 'error-msg' }, errorMessage),
                    !!(successMessage.length) && React.createElement("div", { className: 'success-msg' }, "Document uploaded!"),
                    successfulUploads.length > 0 && React.createElement("div", { className: 'success-msg' },
                        "Success: ",
                        successfulUploads.length,
                        "/",
                        selectedFiles.length),
                    failedUploads.length > 0 && React.createElement("div", { className: 'error-msg' },
                        "Failed: ",
                        failedUploads.length,
                        "/",
                        selectedFiles.length)),
                !successMessage.length && !uploadComplete && React.createElement(Button, { className: 'upload-submit', onClick: submitFiles, disabled: !selectedFiles.length || uploadInProgress }, uploadInProgress ? 'Uploading...' : 'Upload Document(s)'),
                uploadComplete && React.createElement(Button, { className: 'upload-submit', onClick: () => {
                        searchParams.get('refresh')
                            ? searchParams.delete('refresh')
                            : searchParams.set('refresh', 'true');
                        navigate(`${pathname}?${searchParams.toString()}`, { replace: true });
                        onHideModel();
                    } }, "Close and Refresh")))));
};
const UploadDocumentModalWrapper = (props) => {
    return (React.createElement(UploadDocumentProvider, null,
        React.createElement(UploadDocumentModal, Object.assign({}, props))));
};
export default UploadDocumentModalWrapper;
